import { formatResponse, getHeaders } from '@frontend/shared/Util.js';

export async function putScreenSet(screenSet, activeScreens, csrfToken) {
  const response = await fetch(`/api/v1/screen_sets/${screenSet.id}/`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: JSON.stringify({
      'name': screenSet.name,
      'metric_thresholds': activeScreens.map(itm => {
        return {
          'metric_description_id': itm.id,
          'threshold': itm.userPercentile / 100,
        };
      }),
    }),
  });
  return formatResponse(response);
}

export async function postScreenSet(screenSetName, activeScreens, csrfToken, vuid = null) {
  const url = vuid ? '/api/v1/visitor/screen_sets/' : '/api/v1/screen_sets/';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: JSON.stringify({
      'name': screenSetName,
      'metric_thresholds': activeScreens.map((itm) => {
        return {
          'metric_description_id': itm.id,
          'threshold': itm.userPercentile / 100,
        };
      }),
      vuid, // Adding visitor id to request body
    }),
  });
  return formatResponse(response);
}

export async function getScreenSets() {
  const response = await fetch('/api/v1/screen_sets/');
  return formatResponse(response);
}

export async function getFAFNScreenSets() {
  const response = await fetch('/api/v1/vadis_wizard_screensets/');
  return formatResponse(response);
}

export async function getMetrics(vuid=null) {
  let url = '/api/v1/impact_factors/';
  if (vuid) url = `${url}?vuid=${vuid}`;
  const response = await fetch(url);
  return formatResponse(response);
}

export async function getEsgIssues() {
  const response = await fetch(`/api/v1/esgissues/`);
  return formatResponse(response);
}

export async function putEditProspect(sourceId, sourceData, csrfToken, vuid = null, segment = 'prospects') {
  const url = vuid ? '/api/v1/visitor/attach-screen-set/' : `/api/v1/${segment}/${sourceId}/`;
  console.log('putEditProspect.url', url);
  console.log('putEditProspect.vuid', vuid);

  const body = { ...sourceData, vuid };
  console.log('putEditProspect.body', body);

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: JSON.stringify(body),
  });
  return formatResponse(response);
}

export async function getPortfolioData(pathName, clientId) {
  const response = await fetch(`/api/v1/${pathName}/${clientId}/`);
  return formatResponse(response);
}

export async function getPortfolio(portfolioId) {
  const response = await fetch(`/api/v1/portfolios/${portfolioId}/`);
  return formatResponse(response);
}

export async function postSaveExistingClient(clientId, fafnDndx, csrfToken, nameData) {
  console.log('FAFN DATA', fafnDndx);
  const response = await fetch(`/api/v1/integrations/fafn/account_dndx/${clientId}/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: JSON.stringify({
      fafn_dndx: {
        ...fafnDndx,
      },
    }),
  });
  return formatResponse(response);
}

export async function postSaveProspect(prospectData, csrfToken) {
  const response = await fetch(`/advisordashboard/prospect-create/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRFToken': csrfToken,
    },
    body: new URLSearchParams(prospectData),
  });
  return formatResponse(response);
}

export async function getDirectIndexingData() {
  const [prospectsRes, portfoliosRes] = await Promise.all([
    fetch(`/api/v1/workflows/direct_indexing/prospects/`),
    fetch(`/api/v1/workflows/direct_indexing/portfolios/`),
  ]);
  const prospectsData = await prospectsRes.json();
  const portfoliosData = await portfoliosRes.json();
  return {
    prospects: prospectsData.prospects || [],
    portfolios: portfoliosData.portfolios || [],
  };
}

/**
 * Wrapper function for fetch.
 * Automatically includes headers for csrf and oauth tokens when they are present.
 * @param {string} url - The URL to fetch.
 * @param {object} options - The fetch options.
 * @return {Promise<Response>} The fetch response promise.
 */
export function apiFetch(url, options = {}) {
  const defaultHeaders = { 'Content-Type': 'application/json' };
  const csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]')?.value;
  const oauthToken = localStorage.getItem('oauthToken');
  if (csrfToken) defaultHeaders['X-CSRFToken'] = csrfToken;
  if (oauthToken) defaultHeaders['Authorization'] = 'Bearer ' + oauthToken;

  const { headers: specifiedHeaders, ...otherSpecifiedOptions } = options;
  const _options = {
    headers: { ...defaultHeaders, ...specifiedHeaders },
    ...otherSpecifiedOptions,
  };
  return fetch(url, _options);
}

export async function makePostRequest(url, data) {
  const response = await fetch(url, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  return response;
}
